import React from 'react';
import GuestLayout from "./layouts/GuestLayout";
import AuthorizedLayout from './layouts/AuthorizedLayout';
import SecureRoute from "./components/shared/SecureRoute";

import FirstPage from './pages/FirstPage';
//import LoginPage from './pages/LoginPage';
import LogoutPage from './pages/LogoutPage';

import { InternalServerErrorPage, NotFoundPage } from './pages/errors';
import MaterialReceivingHome from './pages/MaterialReceiving/MaterialReceivingHome';
import MaterialReceivingCreate from './pages/MaterialReceiving/MaterialReceivingCreate';
import TransferAtSourceHome from './pages/TransferAtSource/TransferAtSourceHome';
import TransferAtSourceCreate from './pages/TransferAtSource/TransferAtSourceCreate';
import UserManagerHome from './pages/UserManager/UserManagerHome';
import UserManagerCreate from './pages/UserManager/UserManagerCreate';
import TankMidnightHome from './pages/TankMidnight/TankMidnightHome';
import SaleAtExternalHome from './pages/SaleAtExternalTest/SaleAtExternalHome';
import SaleReportHome from './pages/SaleReport/SaleReportHome';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { history } from "./helpers";
import { useSelector } from 'react-redux';
import { ApiErrorDialog } from './components/shared';
import RoleMasterHome from './pages/RoleMaster/RoleMasterHome';
import RoleMasterCreate from './pages/RoleMaster/RoleMasterCreate';
import PlanManagementList from './pages/PlanManagement/PlanManagement';
import PlanManagementCreate from './pages/PlanManagement/PlanCreate';
import PlanDashboard from './pages/PlanManagement/PlanDashboard';
import EmailGroupCreate from './pages/EmailGroup/EmailGroupCreate';
import EmailGroupHome from './pages/EmailGroup/EmailGroupHome';
import EmailAuditHome from './pages/EmailAudit/EmailAuditHome'; 
import EmailAuditDetails from './pages/EmailAudit/EmailAuditDetails';
import OperationTeamMasterHome from './pages/OperationTeamMaster/OperationTeamMasterHome';
import OperationTeamMasterCreate from './pages/OperationTeamMaster/OperationTeamMasterCreate';
import PrivilegeManager from './pages/PrivilegeManager/PrivilegeManager';
import Unauthorized from './pages/Unauthorized';
import AccessDenied from './pages/AccessDenied';
import HomePage from './pages/HomePage';


const themeLight = createMuiTheme({
    button: {
        textTransform: 'uppercase',
        
    },
    palette: {
        background: {
            default: "#b2c5cc"
        },
        primary: {
            main: '#2E94B9',
        },
    },
    overrides: {
        
        MuiButton: {
            containedPrimary: {
                '&.MuiButton-label': {
                    color: 'white'
                },
                '&.Mui-disabled': {
                    color: 'rgba(0, 0, 0, 0.26)'
                },
            },

        },
        MuiInputBase: {
            root: {
                '&.Mui-disabled': {
                    backgroundColor: '#f5f5f5',
                },

            },
        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: 'white',
            },
        },
        MuiIconButton: {
            root: {
                "&:hover": {
                    backgroundColor: "transparent"
                },
            }
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
        },
    }
});

const themeDark = createMuiTheme({
    palette: {
        type: 'dark'
    },
    overrides: {
        MuiIconButton: {
            root: {
                "&:hover": {
                    backgroundColor: "transparent"
                }
            }
        }
    },
    props: {
        MuiButtonBase: {
            disableRipple: true
        },
    }
    
});

const App = () => {
    const currentTheme = useSelector(state => state.theme.isDark)
    return (
        <MuiThemeProvider theme={!currentTheme ? themeLight : themeDark}>
            <CssBaseline />
            <Router history={history}>
                <Switch>

                    <SecureRoute layout={AuthorizedLayout} path='/planning/plan-management/manage' component={PlanManagementList} />
                    <SecureRoute layout={AuthorizedLayout} path='/planning/plan-management/create' component={PlanManagementCreate} />
                    <SecureRoute layout={AuthorizedLayout} path='/planning/plan-management/dashboard' component={PlanDashboard} />

                    <SecureRoute layout={AuthorizedLayout} path='/purchase/material-receiving/home' component={MaterialReceivingHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/purchase/material-receiving/create' component={MaterialReceivingCreate} />

                    <SecureRoute layout={AuthorizedLayout} exact path='/transfer/transfer-at-source' component={TransferAtSourceHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/transfer/transfer-at-source/create' component={TransferAtSourceCreate} />

                    <SecureRoute layout={AuthorizedLayout} path='/sale/sale-at-external/home' component={SaleAtExternalHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/sale/sale-report/home' component={SaleReportHome} />

                    <SecureRoute layout={AuthorizedLayout} path='/tank/tank-midnight/home' component={TankMidnightHome} />

                    <SecureRoute layout={AuthorizedLayout} path='/admin/user-manager/home' component={UserManagerHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/admin/user-manager/manage' component={UserManagerCreate} />
                    <SecureRoute layout={AuthorizedLayout} path='/admin/role-master/home' component={RoleMasterHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/admin/role-master/manage' component={RoleMasterCreate} />
                    {/*<SecureRoute layout={AuthorizedLayout} path='/admin/email-group/home' component={EmailGroupHome} />*/}
                    {/*<SecureRoute layout={AuthorizedLayout} path='/admin/email-group/manage' component={EmailGroupCreate} />*/}
                    {/*<SecureRoute layout={AuthorizedLayout} path='/admin/email-audit/home' component={EmailAuditHome} />*/}
                    {/*<SecureRoute layout={AuthorizedLayout} path='/admin/email-audit/details' component={EmailAuditDetails} />*/}
                    <SecureRoute layout={AuthorizedLayout} path='/admin/operation-team-master/home' component={OperationTeamMasterHome} />
                    <SecureRoute layout={AuthorizedLayout} path='/admin/operation-team-master/manage' component={OperationTeamMasterCreate} />
                    <SecureRoute layout={AuthorizedLayout} path='/admin/privilege-manager' component={PrivilegeManager} />

                    <SecureRoute layout={AuthorizedLayout} path='/access-denied' component={AccessDenied} />

                    <SecureRoute layout={AuthorizedLayout} exact path='/' component={HomePage} />
                    {/*<SecureRoute layout={GuestLayout} path='/login' component={LoginPage} />*/}
                    <SecureRoute layout={GuestLayout} path='/login' component={FirstPage} />
                    <SecureRoute layout={GuestLayout} path='/logout' component={LogoutPage} />
                    <SecureRoute layout={GuestLayout} path='/unauthorized' component={Unauthorized} />
                    <SecureRoute layout={GuestLayout} path='/errors/500' component={InternalServerErrorPage} />
                    <SecureRoute layout={GuestLayout} component={NotFoundPage} />

                </Switch>
            </Router>
            <ApiErrorDialog />
        </MuiThemeProvider>
    );
};
export default App;
